import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditLinkTreeMenuForm from './EditLinkTreeMenuForm'
import LinkTreeMenuLoader from './_load/LinkTreeMenuLoader'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const EditLinkTreeModal = props => {
  return (
    <ControlledModal width="32rem" {...props}>
      <LinkTreeMenuLoader>
        <ModalHeader />
        <HorizontalLine thin lineColor={COLORS.light2} />
        <Separator weight={4} />
        <EditLinkTreeMenuForm />
      </LinkTreeMenuLoader>
    </ControlledModal>
  )
}

export default EditLinkTreeModal
